var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, when, makeObservable } from 'mobx';
import { QuestionPassStateId, QuestionTypeName, TrackIdent } from '../../learnware/LearnwareEnums';
import { runtime } from '../../runtime/Runtime';
import { xa } from '../../../utils/xa/xa';
export class DirectiveCompleteQuestion {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get directive() {
        return this.parent;
    }
    get app() {
        return this.directive.app;
    }
    get question() {
        return this.app.question;
    }
    get answer() {
        return this.app.answer;
    }
    setQuestionComplete() {
        if (!this.answer || !this.question)
            return;
        const answer = this.answer;
        if (answer.completeDate)
            return;
        if (this.question.questionScore.onQuestionComplete) {
            this.question.questionScore.onQuestionComplete();
        }
        const completeDate = this.app.appClock.currentDate;
        if (this.question.questionType !== QuestionTypeName.CycleEnd) {
            this.question.answer.completeDate = completeDate;
        }
        if (this.app.appInfo.isMobileAppWebView) {
            this.app.api.apiNativeApp.sendCompletedEventToWebView();
            return; // answer state is set by app
        }
        const questionStateEntry = this.app.topic.topicFilter.filterQuestionQuery.streamedDeep.find(row => row.qid === this.question.id);
        if (questionStateEntry) {
            questionStateEntry.state = this.nextQuestionPassState;
        }
        const setState = {
            reason: this.nextQuestionPassState,
            timestamp: completeDate.mysqlTimestamp,
            questionId: this.question.id,
        };
        runtime.runtimeScheduler.addToNextIdleStateChange(async () => {
            xa.personalTopic.setQuestionState(setState);
        });
        this.app.funnel.recalculateFunnel();
        if (this.question.questionType === QuestionTypeName.CycleEnd) {
            return;
        }
        if (this.question.questionType === QuestionTypeName.Sortable) {
            const questionSortable = this.question;
            questionSortable.sortableEvents.onWrongComplete();
        }
        if (runtime.availablePackages.Multi && this.app.multi.race.ownRunner) {
            if (this.app.multi.race.raceTime.isRaceRunning) {
                const answerScore = answer.points - 0.5 * answer.avg * answer.maxPoints;
                const averageScore = answer.avg * answer.maxPoints - 0.5 * answer.avg * answer.maxPoints;
                this.app.multi.race.raceAnswer.addAnswer(this.app.multi.race.raceTime.runningSeconds, answerScore, averageScore);
            }
        }
        runtime.runtimeScheduler.addToNextIdleStateChange(async () => {
            await when(() => !!runtime.availablePackages.Defer);
            await xa.answer.insertAnswer({
                id: answer.id,
                question_id: answer.question_id,
                topic_id: this.app.topic.id,
                completeDate: answer.completeDate.mysqlTimestamp,
                points: answer.points,
                maxPoints: answer.maxPoints,
                avg: answer.avg,
                evaltext: answer.evaltext,
            });
            this.app.track.trackEvent({
                ident: TrackIdent.AnswerQuestion,
                question_id: answer.question.id,
                answer_id: answer.id,
                value1: this.app.cycle.frontalNumber.toString(),
            });
            if (this.app.cycle.frontalNumber === 4) {
                if (typeof observerCallback === "function") {
                    observerCallback([{ isIntersecting: true }]);
                }
            }
            /* window.gtag('event', 'Answer', {
               event_category: 'Question',
               event_label: answer.question.id_string,
               value: 1,
             }); */
        });
    }
    get nextQuestionPassState() {
        let currentState = QuestionPassStateId.New;
        if (this.question && this.question.mini) {
            currentState = this.question.mini.miniPassState.questionState;
        }
        if (this.isVocabulary) {
            currentState = QuestionPassStateId.Phase1;
        }
        if (this.isVocabulary && this.question.answeringInfo.reachedPoints < this.question.maxPoints) {
            return currentState;
        }
        if (this.question.answeringInfo.reachedPoints === 0) {
            return QuestionPassStateId.Wrong;
        }
        if (this.hasFullPointsOrReachedThreshold && [QuestionPassStateId.Wrong, QuestionPassStateId.PartialCorrect].includes(currentState)) {
            return QuestionPassStateId.CorrectAfterWrong;
        }
        if (this.hasFullPointsOrReachedThreshold && currentState === QuestionPassStateId.Passed) {
            return QuestionPassStateId.Passed2;
        }
        if (this.hasFullPointsOrReachedThreshold && currentState === QuestionPassStateId.Passed2) {
            return QuestionPassStateId.Passed3;
        }
        if (this.hasFullPointsOrReachedThreshold && currentState === QuestionPassStateId.Phase4 && this.isVocabulary) {
            return QuestionPassStateId.Passed;
        }
        if (this.hasFullPointsOrReachedThreshold && currentState === QuestionPassStateId.Phase3 && this.isVocabulary) {
            return QuestionPassStateId.Phase4;
        }
        if (this.hasFullPointsOrReachedThreshold && currentState === QuestionPassStateId.Phase2 && this.isVocabulary) {
            return QuestionPassStateId.Phase3;
        }
        if (this.hasFullPointsOrReachedThreshold && currentState === QuestionPassStateId.Phase1 && this.isVocabulary) {
            return QuestionPassStateId.Phase2;
        }
        if (this.question.answeringInfo.reachedPoints < this.question.maxPoints) {
            return QuestionPassStateId.PartialCorrect;
        }
        return QuestionPassStateId.Passed;
    }
    get isVocabulary() {
        return false;
        // return !!this.question && this.question.questionType === QuestionTypeName.Vocabulary;
    }
    get hasFullPointsOrReachedThreshold() {
        if (this.question && this.question.questionType === QuestionTypeName.Read) {
            return this.question.answeringInfo.reachedPoints / this.question.maxPoints > 0.8;
        }
        return this.question.answeringInfo.reachedPoints === this.question.maxPoints;
    }
}
__decorate([
    action.bound
], DirectiveCompleteQuestion.prototype, "setQuestionComplete", null);
